import { useEffect, useState } from "react";
import { Layout } from "@/components/Layout";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { getNavFor } from "@/lib/nav";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Zap, Sparkles } from "lucide-react";

const ACTION_LABELS = {
  login: "Signed in", search: "Search", create_user: "Created user", update_user: "Updated user",
  delete_user: "Deleted user", create_branch: "Created branch", upload_resource: "Uploaded resource",
  update_resource: "Updated resource", delete_resource: "Deleted resource", add_web_source: "Added web source",
  update_settings: "Updated settings",
};

export default function Activity() {
  const { user } = useAuth();
  const [logs, setLogs] = useState([]);

  useEffect(() => { api.get("/activity?limit=200").then((r) => setLogs(r.data)).catch(() => {}); }, []);

  const nav = getNavFor(user);
  const showTest = user?.role === "super_admin" || user?.role === "hod";

  const fmt = (iso) => { try { return new Date(iso).toLocaleString(); } catch { return iso; } };

  return (
    <Layout nav={nav} showTestButton={showTest}>
      <h1 className="font-heading text-3xl font-extrabold tracking-tight text-foreground">Activity Log</h1>
      <p className="mt-1 text-sm text-muted-foreground">Real-time record of platform usage across branches and departments.</p>

      <Card className="mt-8 overflow-hidden">
        <Table data-testid="activity-table">
          <TableHeader>
            <TableRow>
              <TableHead>When</TableHead>
              <TableHead>User</TableHead>
              <TableHead>Action</TableHead>
              <TableHead>Details</TableHead>
              <TableHead className="text-right">Source</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {logs.length === 0 && (
              <TableRow><TableCell colSpan={5} className="py-8 text-center text-sm text-muted-foreground">No activity yet.</TableCell></TableRow>
            )}
            {logs.map((l) => (
              <TableRow key={l.id} data-testid={`activity-row-${l.id}`}>
                <TableCell className="whitespace-nowrap text-xs text-muted-foreground">{fmt(l.created_at)}</TableCell>
                <TableCell className="text-sm font-medium">{l.user_name}<div className="text-[11px] uppercase tracking-wide text-muted-foreground">{l.role?.replace("_", " ")}</div></TableCell>
                <TableCell><Badge variant="outline" className="text-xs">{ACTION_LABELS[l.action] || l.action}</Badge></TableCell>
                <TableCell className="max-w-[380px] truncate text-sm text-foreground">{l.query || l.detail || "—"}</TableCell>
                <TableCell className="text-right">
                  {l.action === "search" ? (
                    l.cached
                      ? <Badge className="gap-1 bg-emerald-100 text-emerald-700 hover:bg-emerald-100"><Zap className="h-3 w-3" />cache</Badge>
                      : <Badge className="gap-1 bg-sky-100 text-sky-700 hover:bg-sky-100"><Sparkles className="h-3 w-3" />fresh</Badge>
                  ) : <span className="text-xs text-muted-foreground">—</span>}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </Layout>
  );
}
